import calc from 'calculatorjs'

function addTimeAndTax (fee, ctx) {
  let result = fee
  if (ctx.isTimeIns && ctx.timeInsFee > 0) {
    result = calc.add(result, ctx.timeInsFee)
  }
  if (ctx.finalSrParcelsFeeFormulas?.taxType && !ctx.isAllIncTax) {
    result = calc.add(result, ctx.finalSrParcelsFeeFormulas.taxFee[4])
  }
  return result
}

export function computeOtherFeeBeforeTimeAndTax (ctx) {
  let fee = 0
  fee = calc(`${fee} + ${ctx.jyoBusyFee} + ${ctx.jyoOvldFee} + ${ctx.jyHctCaiFee} + ${ctx.hctPalletFee}`)
  fee = calc(`${fee}+${ctx.isFsFee}+${ctx.isCtnFee}+${ctx.isWsFee}+${ctx.isWbFee}+${ctx.isWxFee}+${ctx.isFccFee}+${ctx.isOwsuFee}`)
  fee = calc(`${fee}+${ctx.jyoApartFee}`)
  fee = calc(`${fee}+${ctx.hmdeFee}`)
  fee = calc(`${fee}+${ctx.otherFeesOtherFee}`)
  if (ctx.sedeFee > 0) {
    fee = calc(`${fee}+${ctx.sedeFee}`)
  }
  fee = calc(`${fee}+${ctx.localFee}`)
  fee = calc(`${fee}+${ctx.vanFee}`)
  if (ctx.premiumFee > 0) {
    fee = calc(`${fee}+${ctx.premiumFee}`)
  }
  return fee
}

export function computeOtherFee (ctx) {
  return addTimeAndTax(computeOtherFeeBeforeTimeAndTax(ctx), ctx)
}

export { addTimeAndTax }
